import {Select, SelectProps} from "@mantine/core";
import Countries from "./Countries";

interface Props extends Omit<SelectProps, "data"> {

}

function State(props: Props) {

    function serializeCountries() {
        return Object.keys(Countries).map((key) => ({value: key, label: Countries[key]}))
    }

    return (
        <Select {...props} data={serializeCountries()}/>
    )

}

export default State;